import React from 'react';
import Layout from '../components/Layout/Layout';
import Hero from '../components/Hero/Hero';

const HomePage = () => {
  return (
    <Layout>
      <Hero />
    </Layout>
  );
};

export default HomePage;
